import { useTranslation } from "@msuite/ui/localization";
import React from "react";
import { CapacityCalendarHeaderItem } from "./capacity-calendar-header-item";
import { CapacityCalendarRowWrapper } from "./capacity-calendar-row-wrapper";
import { useCapacityCalendarContext } from "./context";

export function CapacityCalendarHeader() {
	/** Context */
	const { controller } = useCapacityCalendarContext();
	const { cells, weeks, rangeString, constants } = controller;

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	// Two header rows: the calendar weeks each spanning their seven days, and the days themselves.
	// Both are drawn on the same column template, so a week cell is a span rather than a grid of
	// its own.
	return (
		<React.Fragment>
			<CapacityCalendarRowWrapper variant="header">
				<div className="h-stack h-full">
					<p className="font-semibold">{rangeString}</p>
				</div>
				{weeks.map((week) => (
					<div
						key={week.db()}
						className="flex-center h-full **:text-xs!"
						style={{ gridColumn: `span ${constants.DAYS_PER_WEEK}` }}
					>
						<p className="font-medium">
							{t("planning.calendar_week_short", { week: week.format("WW") })}
						</p>
					</div>
				))}
			</CapacityCalendarRowWrapper>
			<CapacityCalendarRowWrapper variant="header">
				<div className="h-full stripes" />
				{cells.map((cell) => (
					<div
						key={cell.cellMoment.db()}
						className="w-full h-full **:text-xs! relative p-0!"
					>
						<CapacityCalendarHeaderItem cell={cell} />
					</div>
				))}
			</CapacityCalendarRowWrapper>
		</React.Fragment>
	);
}
